export function opacityForStatus<T extends "DONE" | "PENDING">(
  status: T
): number {
  if (status === "DONE") {
    return 0.6;
  }
  return 1;
}
